import { pageHead } from "@/lib/route-head";
import { getAudiencePage } from "@/data/audience-pages";
import { createFileRoute } from "@tanstack/react-router";
import { lazy } from "react";
const AudienceLanding = lazy(() => import("@/pages/AudienceLanding"));

export const Route = createFileRoute("/business-networking-dinners")({
  head: () => { const p = getAudiencePage("business-networking-dinners"); return pageHead({ path: "/business-networking-dinners", title: p?.title ?? "Amorette", description: p?.description ?? "" }); },
  component: AudienceLanding,
});
